import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-modal-footer',
  templateUrl: './modal-footer.component.html',
  styleUrls: ['./modal-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalFooterComponent {}
